import { useState } from 'preact/hooks';
import { IngredientTable } from './ingredient-table';
import { IngredientDetail } from './ingredient-detail';
import { IngredientImpact } from './ingredient-impact';

type View = 'list' | 'detail' | 'impact';

export function IngredientsTab() {
  const [view, setView] = useState<View>('list');
  const [selectedId, setSelectedId] = useState(0);

  const openDetail = (id: number) => {
    setSelectedId(id);
    setView('detail');
  };

  const openImpact = (id: number) => {
    setSelectedId(id);
    setView('impact');
  };

  const backToList = () => {
    setView('list');
  };

  if (view === 'detail') {
    return <IngredientDetail id={selectedId} onBack={backToList} />;
  }

  if (view === 'impact') {
    return <IngredientImpact id={selectedId} onBack={backToList} />;
  }

  return <IngredientTable onSelect={openDetail} onImpact={openImpact} />;
}
